import type { Message } from '@/types/conversations'

interface InfoMessageProps {
  message: Message
}

export function InfoMessage({ message }: InfoMessageProps) {
  const isShort = (message.content?.length || 0) < 80

  return (
    <div className="mb-4 mt-4 min-w-0">
      <div className={`flex gap-2 px-4 py-2 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-lg ${isShort ? 'items-center justify-center' : 'items-start'}`}>
        <svg
          className={`h-4 w-4 text-amber-600 dark:text-amber-400 shrink-0 ${isShort ? '' : 'mt-0.5'}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span className="text-sm text-amber-800 dark:text-amber-200 [overflow-wrap:anywhere] whitespace-pre-wrap">
          {message.content}
        </span>
      </div>
    </div>
  )
}
